import { base_colorAlert, text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md, font_sm, fontH3 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  height: fit-content;

  .ExpensePolicyUploadBox-title {
    ${fontH3};
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${spacing(1)};
    flex-wrap: wrap;
  }

  .ExpensePolicyUploadBox-updateBtn {
    transform: scale(0.7);
  }

  .ExpensePolicyUploadBox-gatedPanel {
    display: flex;
    flex-direction: column;
    gap: ${spacing(4)};
  }

  .ExpensePolicyUploadBox-gatedHeader {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
  }

  .ExpensePolicyUploadBox-gatedBody {
    display: flex;
    min-height: ${spacing(36)};
    align-items: stretch;
    justify-content: center;
    padding: ${spacing(8)} ${spacing(4)};
    text-align: center;
  }

  .ExpensePolicyUploadBox-gatedBody > div {
    width: 100%;
    height: 100%;
  }

  .ExpensePolicyUploadBox-panelMessage {
    ${font_md};
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${text_colorTextSecondary};
    text-align: center;

    p {
      margin: 0;
    }
  }

  .ExpensePolicyUploadBox-gatedButton {
    margin-top: ${spacing(3)};
  }

  .ExpensePolicyUploadBox-memberSubcopy {
    ${font_sm};
    display: inline-flex;
    align-items: center;
    gap: ${spacing(1)};
    margin-top: ${spacing(1)};
    color: ${text_colorTextSecondary};
  }

  .required-asterisk {
    color: ${base_colorAlert};
  }
`
